<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        <span>为什么选择星汉未来</span>
        <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />
        <span>东数西算解决方案?</span>
      </a-typography-title>
      <div class="box_reserve">
        <a-typography-title :level="5">
          星汉未来东数西算解决方案
        </a-typography-title>
        <a-typography-paragraph>
          帮助企业实现低成本的极速数据迁移，显著降低数字化运营成本。
          此方案核心技术经国家发明专利认证及计算机软件著作认证，技术专业度有保障。
        </a-typography-paragraph>
        <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
          <a-button type="link" class="button_1"
                  @click="localTo('https://dtexpress.galaxy-future.com/#/login')">
          免费体验
        </a-button>
          <a-button type="link" class="button_1"
                    @click="$Store.Page().openModal('modalFormCollection','demo')">
            预约咨询
          </a-button>
        </a-space>
      </div>
      <a-row :gutter="[50,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?20:5]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :lg="12">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_why',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '极速迁移',
            text: '利用算力调度引擎BridgX快速获取上万台机器实现并行传输，10分钟完成10TB数据的跨云跨地域迁移。'
          },
          {
            title: '成本极低',
            text: '系统根据传输数据量等参数为您实时计算迁移费用，成本远低于上述几种传统迁移方案。'
          },
          {
            title: '操作简单',
            text: '提供简洁易用的数据迁移界面，操作简单易上手，无需复杂配置，即可轻松启动迁移。'
          },
          {
            title: '定制化优化方案',
            text: '支持弹性扩展迁移资源，稳定高效。支持各种类型NAS、CPFS等存储介质。'
          }
        ]
      }
    };
  },
  methods: {
    localTo(url:string):void{
      window.open(url,'_blank')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planMigrate/';

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_reserve {
  overflow: hidden;
  position: relative;
  padding: 30px 20px 30px 130px;
  margin: @margin 0 0;
  border: 2px solid @color_14;
  border-radius: 8px;
  .bg('@{image}why_bg.jpg');
  background-size: cover;
  background-position-x: 0;
  
  &::before,
  &::after {
    content: '';
    display: block;
    z-index: 0;
    pointer-events: none;
  }
  
  &::before {
    @scale: 0.7;
    .position(absolute, auto, 8%, 0, auto);
    .bg('@{image}why_image.png', 358px*@scale, 246px*@scale, true);
  }
  
  &::after {
    .position(absolute, 10px, auto, auto, 30px);
    .bg('@{image}why_point.png', 70px, 70px, true);
  }
  
  h5.ant-typography {
    z-index: 1;
    margin: 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    z-index: 1;
    max-width: 640px;
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 70px;
  position: relative;
  min-height: 92px;
  padding: 5px 20px 5px 90px;
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        background-position-x: -(-1+@i)*@wh;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 0, auto, auto, 0);
    z-index: 0;
    width: @wh;
    height: @wh;
    .bg('@{image}why_icon.png', @wh*4, @wh);
  }
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text+@line, @color_13, @text);
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .box_reserve {
    padding: 20px;
    
    &::after {
      display: none;
    }
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_reserve {
    &::before {
      @scale: 0.5;
      .position(absolute, auto, 0, 0, auto);
      .bg('@{image}why_image.png', 358px*@scale, 246px*@scale, true);
    }
    
    .ant-space {
      margin: 60px 0 0;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .box_reserve {
    margin: @margin_mo 0 0;
    
    h5.ant-typography {
      .font(justify, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    max-width: 350px;
    min-height: auto;
    padding: 0;
    margin: 0 auto;
    
    &::before {
      .position(absolute, -25px, auto, auto, -25px);
      margin: 0;
      .transform(scale(0.4));
    }
    
    h5.ant-typography {
      padding: 0 0 0 35px;
      margin: @margin_mo 0 0;
      .font(justify, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
}
</style>